import {
  getEventList,
  getEventById,
  postEvent,
  updateEvent,
  deleteEvent,
  //Uploads
  getEventUploadByEventId,
  postEventUpload,
  deleteEventUpload,
} from "@/services/event.service";
import { formatDateEdit } from "@/utils/utils";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  eventModel: {},
});

// mutations
const mutations = {
  setEventModel(state, data) {
    state.eventModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadEventList(vuexContext, co) {
    return await getEventList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;

        // item.lecturerId = item.personListDto[0]?.personDto?.personId;

        let lecturerName = "";

        // item.personListDto?.forEach((element, index) => {
        //   if (element.personDto) {
        //     lecturerName += element.personDto.name + " " + element.personDto.lastName;
        //     if (item.personListDto.length > index && item.personListDto.length != index + 1) lecturerName += ", ";
        //   }
        // });

        //Message Details
        item.classLevel = item.class.levels?.description;
        // item.classType = item.classEventDto.educationTypeDto.name;
        item.lecturerName = lecturerName;

        item.startDate = formatDateEdit(item.startDate);
        item.finishDate = formatDateEdit(item.finishDate);
      });

      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async loadEventById(vuexContext, eventId) {
    return await getEventById(eventId).then((response) => {
      let data = response.data.data;
      data.classLevel = data.classEventDto?.levelsDto?.description;
      data.classType = data.classEventDto?.educationTypeDto?.name;

      let lecturerName = "";

      data.personListDto.forEach((element, index) => {
        lecturerName += element.personDto?.name + " " + element.personDto?.lastName;
        if (data.personListDto.length > index && data.personListDto.length != index + 1) lecturerName += ", ";
      });
      data.lecturerName = lecturerName;

      data.StartDate = formatDateEdit(data.startDate);
      data.FinishDate = formatDateEdit(data.finishDate);
      return data;
    });
  },

  async postEvent(vuexContext, data) {
    return await postEvent(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateEvent(vuexContext, data) {
    return await updateEvent(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteEvent(vuexContext, data) {
    return await deleteEvent(data).then((response) => {
      let data = response;
      return data;
    });
  },

  //Event Uploads
  async loadEventUploadListByEventId(vuexContext, co) {
    return await getEventUploadByEventId(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async postEventUpload(vuexContext, data) {
    return await postEventUpload(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteEventUpload(vuexContext, data) {
    return await deleteEventUpload(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addEventModel(vuexContext, data) {
    vuexContext.commit("setEventModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
